import logo from '~/assets/images/CBR Logo.svg';

const images = {
  logo
};

export default images;
